<template>
  <div class="row">
    <div v-if="!$store.state.auth.is_authenticated" class="col-12 pb-3">
      <a v-bind:href="homeDomain" class="fc-a-logo fc-a-logo--noauth">
        <img
          class="fc-a-logo__image"
          alt="Fantasy Congress Logo"
          src="@/assets/images/logo-centered.png"
        />
      </a>
    </div>
    <div class="col-12">
      <article class="fc-m-container fc-invite">
        <h2>Sign up by invite</h2>
        <div class="row p-0">
          <div class="col-12">
            <p>
              Invited to play in a league? Sign up here!
            </p>

            <form @submit="signupSubmit">
              <div class="form-group">
                <label for="username">Username *</label>
                <input
                  v-model="username"
                  class="form-control"
                  type="text"
                  name="username"
                  value=""
                />
              </div>
              <div class="form-group">
                <label for="email">Email *</label>
                <input
                  v-model="email"
                  class="form-control"
                  type="email"
                  name="email"
                  value=""
                />
              </div>
              <div class="form-group">
                <label for="password1">Password *</label>
                <input
                  v-model="password1"
                  class="form-control"
                  type="password"
                  name="password1"
                  value=""
                />
              </div>
              <div class="form-group">
                <label for="password2">Confirm Password *</label>
                <input
                  v-model="password2"
                  class="form-control"
                  type="password"
                  name="password2"
                  value=""
                />
              </div>
              <p class="small">* indicates field is required</p>
              <button type="submit" class="btn btn-primary">Submit</button>
            </form>
            <div class="mt-4 small">
              Already have an account? 
              <router-link
                to="/login"
                class="fc-a-link--casual"
              >
                  Login
              </router-link>
            </div>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>
<script>
import { getCookie } from "@/utils/cookies.js";
import { handleErrors } from "@/utils/errors.js";

export default {
  name: "Invite",
  data: function() {
    return {
      username: "",
      email: "",
      password1: "",
      password2: "",
      homeDomain: process.env.VUE_APP_HOME_DOMAIN
    };
  },
  created: function() {
    if (this.$store.state.auth.is_authenticated == true) {
      this.$router.push("/leagues");
    } else {
      const csrftoken = getCookie("csrftoken");
    }
  },
  methods: {
    loginNewUser: function() {
      let app = this;
      app.$store.dispatch("auth/loginCheck").then(function(checkResult) {
        if (checkResult) {
          app.$router.push("/leagues/");
          app.$store.commit("alert/addMessage", {
            message: `Success! Welcome to Fantasy Congress.`,
            class: "success",
            persist: false
          });
        } else {
          app.$store.commit("alert/addMessage", {
            message: "Login failed. Please refresh and try again.",
            class: "danger",
            persist: false
          });
        }
      });
    },
    signupSubmit: function(e) {
      e.preventDefault();

      let app = this;
      const csrftoken = getCookie("csrftoken");
      let status = null;
      let form = new URLSearchParams({
        username: app.username,
        email: app.email,
        password1: app.password1,
        password2: app.password2
      });

      fetch(`${process.env.VUE_APP_PLATFORM}/signup/invite/`, {
        credentials: "include",
        method: "POST",
        mode: "cors",
        body: form,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-CSRFToken": csrftoken
        }
      })
        .then(function(response) {
          app.$store.commit("alert/deletePageMessages");
          status = response.ok;
          return response.json();
        })
        .then(function(response) {
          if (status) {
            app.loginNewUser();
          } else {
            handleErrors(response.errors);
          }
        })
        .catch((error) => {
          app.$store.commit("alert/addMessage", {
            message: `error: Something went wrong. Please refresh and try again.`,
            class: "danger",
            persist: false
          });

          app.$store.commit("alert/addMessage", {
            message: `error: ${error}.`,
            class: "danger",
            persist: false
          });
        })
        .finally(() => {
          app.submitted = false;
        });
    }
  }
};
</script>
<style>
.fc-invite {
  max-width: 500px;
  margin: auto;
}
</style>
